 
<template>
  <j-select-biz-component :width="1000" returnId v-bind="configs" v-on="$listeners" />
</template>

<script>
  import JSelectBizComponent from './JSelectBizComponent'

  export default {
    name: 'JSelectPublic',
    components: { JSelectBizComponent },
    props: {
      value: {
        type: String,
        default: ''
      },
      settings: {
        type: Object,
        default: () => { }
      }
    },
    data () {
      return {

      }
    },
    created () {

    },
    computed: {
      configs () {
        return Object.assign({ value: this.value }, this.settings, this.$attrs)
      }
    },
    created () {

    }
  }
</script>

<style lang="less" scoped></style>
